/**
 * RelationshipService
 * Service for Relationship entity operations
 * Route: api/relationships
 * Controller: RelationshipsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RelationshipService
 * Handles relationship CRUD operations (cached lookup table)
 * Maps to /api/relationships endpoint
 */
export class RelationshipService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RelationshipService.DEFAULT_SERVICE_PATH,
            basePath: RelationshipService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RelationshipService.DEFAULT_SERVICE_PATH = 'members';
RelationshipService.BASE_PATH = 'api/relationships';
//# sourceMappingURL=RelationshipService.js.map